import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LearningTrailsService } from '@app/core';
import { BehaviorSubject, Observable, Subject, finalize, map } from 'rxjs';
import { Course } from '../../models';
import { TrailsService } from '../../services';

@Component({
  templateUrl: './modal-subdivisions.component.html',
  standalone: false,
})
export class ModalSubdivisionsComponent implements OnInit, OnDestroy {
  private isShowcase = false;

  public subdivisionBar$ = new BehaviorSubject<any>(undefined);
  public loading$ = new Subject<boolean>();

  constructor(
    private router: Router,
    private learningTrailsService: LearningTrailsService,
    private trailsService: TrailsService,
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: any,
  ) {}

  public ngOnInit() {
    this.loading$.next(true);
    this.isShowcase = !!this.data?.isShowcase;
    this.updateSubdivision(this.data?.course);
  }

  public ngOnDestroy(): void {
    this.subdivisionBar$.complete();
    this.loading$.complete();
  }

  public onOpenSubdivision(course: Course): void {
    this.loading$.next(true);
    if (!!course?.subdivisoes?.length) {
      this.updateNextSubdivision(course);
    } else if (this.isShowcase) {
      this.dialogRef.close({ reset: true });
      this.router.navigate([this.getUrlUcIvca(), 'vitrine', course.slug]);
    } else {
      this.dialogRef.close({ reset: true });
      this.router.navigate([this.getUrlUcIvca(), 'cursos', course?.evento?.id, course.slug]);
    }
  }

  private updateSubdivision(course: Course): void {
    if (!!course?.subdivisoes?.length) {
      this.getSubdivision(course.slug, course.evento?.id)
        .pipe(
          finalize(() => this.loading$.next(false)),
          map(({ data }) => data.subdivisoes.map((sub) => ({ ...sub, evento: { id: course?.evento?.id } }))),
        )
        .subscribe((data) => this.subdivisionBar$.next(data));
    } else if (!!course?.trilhas?.length) {
      this.getSubdivision(course.slug, course.evento?.id)
        .pipe(
          finalize(() => this.loading$.next(false)),
          map(({ data }) => data.trilhas?.map((trail) => ({ ...trail, evento: { id: course?.evento?.id } }))),
        )
        .subscribe((data) => this.subdivisionBar$.next(data));
    } else {
      this.loading$.next(false);
    }
  }

  private updateNextSubdivision(course: Course): void {
    this.learningTrailsService
      .subdivisions('proxima-subdivisao/' + course.slug)
      .pipe(
        finalize(() => this.loading$.next(false)),
        map(({ data }) => {
          if (!!data?.trilhas?.length) {
            return data.trilhas.map((trail) => ({ ...trail, evento: { id: course.evento.id } }));
          }
          return data.subdivisoes.map((sub) => ({ ...sub, evento: { id: course.evento.id } }));
        }),
      )
      .subscribe((data) => this.subdivisionBar$.next(data));
  }

  private getSubdivision(slug: string, evento_id: number): Observable<any> {
    return this.learningTrailsService.subdivisions(slug, evento_id);
  }

  private getUrlUcIvca(): string {
    if (this.trailsService.uc$.value) return 'universidade-corporativa';
    if (this.trailsService.ivca$.value) return 'ivca';
    return 'trilhas-de-aprendizagem';
  }
}
